/** @format */

import LazyLoad from "./library/LazyLoad";
import RejMessages from "./library/RejMessages";
import Forms from "./components/Forms";
import FormsValidation from "./components/FormsValidation";
import Popups from "./components/Popups";
import Carousels from "./components/Carousels";
import ValuationAnimations from "./components/ValuationAnimations";
import Tabs from "./components/Tabs";
import Background from "./components/Background";
import ProgressBar from "./components/ProgressBar";
import BusinessSearch from "./components/BusinessSearch";
import Favourites from "./components/Favourites";
import Navigation from "./components/Navigation";
import Insights from "./components/Insights";
import Guides from "./components/Guides";
import SoldBusinesses from "./components/SoldBusinesses";
import Copy from "./components/Copy";
import Video from "./components/Video";
import Accordion from "./components/Accordion";
import Content from "./components/Content";
import GoogleAutoComplete from "./components/GoogleAutoComplete";
import Sectors from "./components/Sectors";
import SaveSearch from "./components/SaveSearch";
import Dashboard from "./components/Dashboard";
import Dropdown from "./components/Dropdown";
import Tooltip from "./components/Tooltip";
import SortableItems from "./components/SortableItems";
import StatusBar from "./components/StatusBar";

import Helpers from "./library/Helpers";
import $ from "jquery";

// Required for IE
require("./library/AssignPolyfill.js");

global.jQuery = global.$ = $;

require("./library/GoogleMaps.js");

$(() => {
	// Plugins
	require("./plugins/ImagesLoaded.js");
	require("./plugins/Modernizr.js");
	require("./../../node_modules/magnific-popup/dist/jquery.magnific-popup.js");
	require("./../../node_modules/slick-carousel/slick/slick.js");
	require("./../../node_modules/select2/dist/js/select2.js");
	require("jquery-countto/jquery.countTo.js");
	require("./../../node_modules/pickadate/lib/picker.js");
	require("./../../node_modules/pickadate/lib/picker.date.js");
	require("./../../node_modules/pickadate/lib/picker.time.js");

	require("./library/StubConsole.js");
	require("./library/Request.js");
	require("./library/ReplaceAll.js");

	LazyLoad.init();
	RejMessages.init();
	Forms.init();
	FormsValidation.init();
	Carousels.init();
	Popups.init();
	ValuationAnimations.init();
	Tabs.init();
	Background.init();
	ProgressBar.init();
	BusinessSearch.init();
	Favourites.init();
	Navigation.init();
	Insights.init();
	Guides.init();
	SoldBusinesses.init();
	Copy.init();
	Video.init();
	Accordion.init();
	Content.init();
	GoogleAutoComplete.init();
	Sectors.init();
	SaveSearch.init();
	Dashboard.init();
	Dropdown.init();
	SortableItems.init();
	Tooltip.init();
	StatusBar.init();
});
